/**
 * Fallback minimum card charge, used only until the billing summary (the
 * backend's authoritative `minChargeUsd`) has loaded. Keep in sync with the
 * backend constant of the same value.
 */
export const MIN_CARD_CHARGE_USD = 25;
